// extracted by mini-css-extract-plugin
module.exports = {"headline":"policy_headline__TayLh","content":"policy_content__RcfsS","container":"policy_container__0cQSX"};